var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.604,
    height: 116.679,
    viewBox: "0 0 171.604 116.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_934",
    "data-name": "Grupo 934",
    transform: "translate(11339.604 -12856.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_personal_text_re_vqj3",
    transform: "translate(-11339.604 12856.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15986",
    "data-name": "Trazado 15986",
    d: "M860.135,629.117c-3.849,2.773-8.836,2.912-13.657,2.571-.673-.048-1.342-.1-2-.163l-.013,0-.094-.008-.409-.038.032.061.1.189-.108-.189-.033-.057a19.08,19.08,0,0,1-2.8-6.908c-.327-2.576.591-5.493,2.858-6.759a4.577,4.577,0,0,1,.939-.393c.136-.041.273-.075.412-.1a4.9,4.9,0,0,1,5.7,6.374c1.922-1.971,1.564-5.168.9-7.841s-1.469-5.646-.117-8.046a5.305,5.305,0,0,1,3.554-2.5l.136-.028a7.157,7.157,0,0,1,5.141.9c2.834,1.786,4.29,5.172,4.762,8.49C866.2,620.007,864.511,625.965,860.135,629.117Z",
    transform: "translate(-706.187 -515.206)",
    fill: "#5de280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15987",
    "data-name": "Trazado 15987",
    d: "M870.107,621.1a12.163,12.163,0,0,1-.84,3.428,10.564,10.564,0,0,1-1.64,2.679,13.534,13.534,0,0,1-5.2,3.749,19.483,19.483,0,0,1-4.736,1.273c-.673-.047-1.342-.1-2-.163l-.013,0-.094-.008-.409-.038.032.061.1.189-.108-.189-.033-.057a10.672,10.672,0,0,0,.994-14.06c.136-.041.273-.075.412-.1a11.258,11.258,0,0,1,1.027,1.7,11.033,11.033,0,0,1,.952,6.863,11.28,11.28,0,0,1-2.858,5.626c.129-.009.258-.02.385-.031a19.778,19.778,0,0,0,6.991-1.781,12.591,12.591,0,0,0,4.717-3.87,11.379,11.379,0,0,0,2-6.245,26.354,26.354,0,0,0-.748-7.135,29.944,29.944,0,0,0-2.516-6.855.215.215,0,0,1,.086-.284.183.183,0,0,1,.136-.028.159.159,0,0,1,.105.09c.138.268.273.537.4.809a30.283,30.283,0,0,1,2.371,7.112A24.382,24.382,0,0,1,870.107,621.1Z",
    transform: "translate(-717.402 -515.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15988",
    "data-name": "Trazado 15988",
    d: "M185.795,200.586a.923.923,0,0,1-.335-.063.911.911,0,0,1-.584-.854v-9.577a1.224,1.224,0,0,0-1.223-1.223h-1.961a3.06,3.06,0,0,1-3.056-3.056V166.556a3.06,3.06,0,0,1,3.056-3.056h69.178a3.06,3.06,0,0,1,3.056,3.056v19.256a3.06,3.06,0,0,1-3.056,3.056h-53.4a1.226,1.226,0,0,0-.9.4l-10.1,11.023A.911.911,0,0,1,185.795,200.586Zm-4.1-36.679a2.652,2.652,0,0,0-2.649,2.649v19.256a2.652,2.652,0,0,0,2.649,2.649h1.961a1.632,1.632,0,0,1,1.63,1.63v9.577a.51.51,0,0,0,.885.344l10.1-11.023a1.634,1.634,0,0,1,1.2-.529h53.4a2.652,2.652,0,0,0,2.649-2.649V166.556a2.652,2.652,0,0,0-2.649-2.649Z",
    transform: "translate(-178.635 -163.5)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_274",
    "data-name": "Elipse 274",
    cx: 2.674,
    cy: 2.674,
    r: 2.674,
    transform: "translate(4.822 3.324)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15989",
    "data-name": "Trazado 15989",
    d: "M266.326,254.473H203.389a1.426,1.426,0,1,1,0-2.853h62.938a1.426,1.426,0,1,1,0,2.853Z",
    transform: "translate(-197.212 -233.676)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15990",
    "data-name": "Trazado 15990",
    d: "M245.823,224.7H203.389a1.426,1.426,0,1,1,0-2.853h42.434a1.426,1.426,0,1,1,0,2.853Z",
    transform: "translate(-197.212 -209.969)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15991",
    "data-name": "Trazado 15991",
    d: "M185.795,534.182a.924.924,0,0,1-.335-.063.911.911,0,0,1-.584-.854v-9.577a1.224,1.224,0,0,0-1.223-1.223h-1.961a3.06,3.06,0,0,1-3.056-3.056V500.153a3.06,3.06,0,0,1,3.056-3.056h69.178a3.06,3.06,0,0,1,3.056,3.056v19.256a3.06,3.06,0,0,1-3.056,3.056h-53.4a1.226,1.226,0,0,0-.9.4l-10.1,11.023A.911.911,0,0,1,185.795,534.182Zm-4.1-36.679a2.652,2.652,0,0,0-2.649,2.649v19.256a2.652,2.652,0,0,0,2.649,2.649h1.961a1.632,1.632,0,0,1,1.63,1.63v9.577a.51.51,0,0,0,.885.344l10.1-11.023a1.634,1.634,0,0,1,1.2-.529h53.4a2.652,2.652,0,0,0,2.649-2.649V500.153a2.652,2.652,0,0,0-2.649-2.649Z",
    transform: "translate(-178.635 -429.166)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15992",
    "data-name": "Trazado 15992",
    d: "M449.025,360.818a.911.911,0,0,1-.673-.3l-10.1-11.023a1.226,1.226,0,0,0-.9-.4h-53.4a3.06,3.06,0,0,1-3.056-3.056V326.788a3.06,3.06,0,0,1,3.056-3.056h69.178a3.06,3.06,0,0,1,3.056,3.056v19.256a3.06,3.06,0,0,1-3.056,3.056h-1.961a1.224,1.224,0,0,0-1.223,1.223V359.9a.911.911,0,0,1-.584.854.922.922,0,0,1-.335.063Zm-65.075-36.679a2.652,2.652,0,0,0-2.649,2.649v19.256a2.652,2.652,0,0,0,2.649,2.649h53.4a1.634,1.634,0,0,1,1.2.529l10.1,11.023a.51.51,0,0,0,.885-.344v-9.577a1.632,1.632,0,0,1,1.63-1.63h1.961a2.652,2.652,0,0,0,2.649-2.649V326.788a2.652,2.652,0,0,0-2.649-2.649Z",
    transform: "translate(-339.708 -291.104)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_275",
    "data-name": "Elipse 275",
    cx: 2.674,
    cy: 2.674,
    r: 2.674,
    transform: "translate(4.822 71.254)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15993",
    "data-name": "Trazado 15993",
    d: "M266.326,588.069H203.389a1.426,1.426,0,1,1,0-2.853h62.938a1.426,1.426,0,1,1,0,2.853Z",
    transform: "translate(-197.212 -499.343)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15994",
    "data-name": "Trazado 15994",
    d: "M245.823,558.3H203.389a1.426,1.426,0,0,1,0-2.853h42.434a1.426,1.426,0,0,1,0,2.853Z",
    transform: "translate(-197.212 -475.635)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_276",
    "data-name": "Elipse 276",
    cx: 2.674,
    cy: 2.674,
    r: 2.674,
    transform: "translate(46.008 35.773)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15995",
    "data-name": "Trazado 15995",
    d: "M468.586,413.829H405.648a1.426,1.426,0,1,1,0-2.853h62.938a1.426,1.426,0,0,1,0,2.853Z",
    transform: "translate(-358.285 -360.583)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15996",
    "data-name": "Trazado 15996",
    d: "M448.082,384.059H405.648a1.426,1.426,0,0,1,0-2.853h42.434a1.426,1.426,0,0,1,0,2.853Z",
    transform: "translate(-358.285 -336.875)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15997",
    "data-name": "Trazado 15997",
    d: "M719.99,496.6a2.048,2.048,0,0,1,2.768-1.482l4.777-5.489,1.015,3.643-4.692,4.654a2.059,2.059,0,0,1-3.868-1.326Z",
    transform: "translate(-609.717 -423.217)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15998",
    "data-name": "Trazado 15998",
    d: "M627.028,509.713h-2.5l-1.188-9.629h3.685Z",
    transform: "translate(-496.413 -398.252)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15999",
    "data-name": "Trazado 15999",
    d: "M791.717,710.1h-8.05V710a3.133,3.133,0,0,1,3.133-3.133h4.917Z",
    transform: "translate(-660.465 -596.223)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16000",
    "data-name": "Trazado 16000",
    d: "M667.321,522.714h-2.5l-.346-9.4,2.843-.23Z",
    transform: "translate(-529.172 -408.606)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16001",
    "data-name": "Trazado 16001",
    d: "M828.717,723.1h-8.05V723a3.133,3.133,0,0,1,3.133-3.133h4.917Z",
    transform: "translate(-689.931 -606.576)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16002",
    "data-name": "Trazado 16002",
    d: "M807.018,568.825l-1.944-.229a.919.919,0,0,1-.809-.9L803.9,542.38a.305.305,0,0,0-.593-.1l-2.7,7.616.193,14.275a.916.916,0,0,1-.861.927l-2.538.108a.922.922,0,0,1-.966-.8l-1.326-16.148v-.01l2.011-16.864,15.106,1.093-4.193,35.543a.918.918,0,0,1-.909.809A.907.907,0,0,1,807.018,568.825Z",
    transform: "translate(-669.579 -456.474)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16003",
    "data-name": "Trazado 16003",
    d: "M803.43,430.877a.911.911,0,0,1-.479-.737s1.358-8.447,1.856-8.606l-1.089-9.034a8.33,8.33,0,0,1,1.788-6.209,7.944,7.944,0,0,1,5.5-2.949q.228-.021.454-.031a8.016,8.016,0,0,1,6.747,3.071,8.169,8.169,0,0,1,1.47,7.413l-.611,2.126v14.856a.927.927,0,0,1-.379.744,10.158,10.158,0,0,1-6.141,1.89A20.759,20.759,0,0,1,803.43,430.877Z",
    transform: "translate(-675.822 -354.47)",
    fill: "#73554a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16004",
    "data-name": "Trazado 16004",
    d: "M736,442.923l-2.627-1.965a.916.916,0,0,1-.122-1.359l15.652-16.794a3.065,3.065,0,0,1,3.975-.423h0a3.05,3.05,0,0,1,.392,4.679l-16.079,15.782a.911.911,0,0,1-1.092.144A.935.935,0,0,1,736,442.923Z",
    transform: "translate(-620.122 -369.234)",
    fill: "#73554a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16005",
    "data-name": "Trazado 16005",
    d: "M845.827,493.194a2.048,2.048,0,0,1,3-.938l5.719-4.5.316,3.768-5.479,3.695a2.059,2.059,0,0,1-3.552-2.026Z",
    transform: "translate(-709.838 -421.728)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16006",
    "data-name": "Trazado 16006",
    d: "M858.376,436.618a.909.909,0,0,1-.616-.662l-.578-2.426a.9.9,0,0,1,.336-.939l3.887-4.2-5.718-8.816a3.1,3.1,0,1,1,5.26-3.183l5.316,10.347a4.708,4.708,0,0,1-1.572,6.067l-5.432,3.629a.908.908,0,0,1-.6.232A.927.927,0,0,1,858.376,436.618Z",
    transform: "translate(-717.267 -363.397)",
    fill: "#73554a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16008",
    "data-name": "Trazado 16008",
    d: "M716.355,734.7a.2.2,0,0,1-.2.2H638.569a.2.2,0,0,1,0-.407h77.583a.2.2,0,0,1,.2.2Z",
    transform: "translate(-544.751 -618.228)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_928",
    "data-name": "Grupo 928",
    transform: "translate(-13.167 33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16188",
    "data-name": "Trazado 16188",
    d: "M2302.839,70.554s-2.854-3.53-1.657-4.931,3.049,0,3.049,0a1.634,1.634,0,0,1,1.949-1.486,4.424,4.424,0,0,1,2.959,2.139s1.625-1.626,2.737,0,.342,4.278.342,4.278,1.283-.19.941,1.317-2.361,3.06-2.361,3.06Z",
    transform: "translate(-13496.716 12793.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16199",
    "data-name": "Trazado 16199",
    d: "M2348.053,238.625l.053,3.981s-.7,1.154-3.029,1.375a4.127,4.127,0,0,1-2.348-.219l.215-2.02.212-1.969,4.193-.982Z",
    transform: "translate(-13535.684 12631.059)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16200",
    "data-name": "Trazado 16200",
    d: "M2350.26,241.035a1.3,1.3,0,0,1-.11.386c-.864,2-3.293,2.462-4.294,2.566l.212-1.969Z",
    transform: "translate(-13538.594 12628.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16189",
    "data-name": "Trazado 16189",
    d: "M2315.608,102.953s-2.022,5.02-1.161,7.782,3.385,2.25,4.887,1.668a5.021,5.021,0,0,0,2.18-1.534,2.274,2.274,0,0,0,1.8-4.074,2.225,2.225,0,0,0-1.765.289l.712-1.463s-3.387-7.229-6.658-2.669",
    transform: "translate(-13509.144 12758.815)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16193",
    "data-name": "Trazado 16193",
    d: "M2420.82,195.144a.184.184,0,0,1-.109-.332l1.5-1.11a.184.184,0,1,1,.219.3l-1.5,1.11a.183.183,0,0,1-.11.036",
    transform: "translate(-13608.237 12672.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16194",
    "data-name": "Trazado 16194",
    d: "M2428.544,205.635a.183.183,0,0,1-.043-.005l-1.186-.288a.184.184,0,0,1,.087-.358l1.186.288a.184.184,0,0,1-.044.363",
    transform: "translate(-13614.327 12662.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16191",
    "data-name": "Trazado 16191",
    d: "M2362.7,141.817a.184.184,0,0,1-.173-.122.893.893,0,0,0-.98-.648.184.184,0,0,1-.065-.363,1.256,1.256,0,0,1,1.392.887.185.185,0,0,1-.112.235.182.182,0,0,1-.062.011",
    transform: "translate(-13553.002 12722.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16195",
    "data-name": "Trazado 16195",
    d: "M2324.417,142.131a.184.184,0,0,1-.12-.325c.177-.15.646-.548.859-.308a.184.184,0,0,1-.191.3,1.449,1.449,0,0,0-.429.291.183.183,0,0,1-.119.044",
    transform: "translate(-13518.456 12721.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16196",
    "data-name": "Trazado 16196",
    d: "M2332.91,174.525a.184.184,0,0,1-.146-.073c-.647-.848.6-2.188.649-2.245a.184.184,0,1,1,.268.252c-.3.323-1,1.27-.625,1.769a.184.184,0,0,1-.035.258.181.181,0,0,1-.112.038",
    transform: "translate(-13526.228 12692.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16197",
    "data-name": "Trazado 16197",
    d: "M2330.186,163.159l-.026,0a.185.185,0,0,1-.156-.208l.134-.937a.186.186,0,0,1,.209-.156.184.184,0,0,1,.156.209l-.134.937a.185.185,0,0,1-.182.158",
    transform: "translate(-13523.828 12702.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16192",
    "data-name": "Trazado 16192",
    d: "M2370.128,163.109a.186.186,0,0,1-.184-.2l.06-.945a.18.18,0,0,1,.2-.172.184.184,0,0,1,.172.2l-.06.945a.185.185,0,0,1-.184.173",
    transform: "translate(-13561.027 12702.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16190",
    "data-name": "Trazado 16190",
    d: "M2323.065,89.644a1.681,1.681,0,0,1,1.414-.826,2.148,2.148,0,0,1,1.583.671,2.443,2.443,0,0,0,.949,2.548,3.3,3.3,0,0,0,2.4.608l.975-.362.7-1.441-2.875-3.016-3.693-1.887-1.846,1.722Z",
    transform: "translate(-13517.005 12773.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16198",
    "data-name": "Trazado 16198",
    d: "M2349.663,214.356c-.044,0-.072,0-.079,0a.184.184,0,0,1-.168-.2.182.182,0,0,1,.2-.169,1.161,1.161,0,0,0,1.118-.649.184.184,0,1,1,.335.152,1.507,1.507,0,0,1-1.4.867",
    transform: "translate(-13541.909 12654.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16201",
    "data-name": "Trazado 16201",
    d: "M2335.417,295.661a9.1,9.1,0,0,1-2.3-.293.184.184,0,0,1,.1-.354,8.951,8.951,0,0,0,2.769.258,7.394,7.394,0,0,0,3.316-1.338.184.184,0,0,1,.222.294,7.635,7.635,0,0,1-3.511,1.411c-.205.015-.407.022-.6.022",
    transform: "translate(-13526.61 12579.584)",
    fill: "#ffbf69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16202",
    "data-name": "Trazado 16202",
    d: "M12.878,3.314a2.047,2.047,0,0,0,1.349-1.041,1.217,1.217,0,0,0,.074-.581,1.422,1.422,0,0,0-.31-.66C13.05-.091,9.186,0,9.186,0,6.593.065,5.218.245,3.065.34,1.858.394.827.4.059.4A.059.059,0,0,0,.047.513l12.831,2.8",
    transform: "translate(-11183.498 12864.707) rotate(-169)",
    fill: "#c6783a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16203",
    "data-name": "Trazado 16203",
    d: "M3.493,5.07l-1.1-3.39A2.773,2.773,0,0,1,.837.432,2.3,2.3,0,0,1,.661,0L.376.124a.626.626,0,0,0-.333.8L1.321,4.2Z",
    transform: "matrix(-0.857, -0.515, 0.515, -0.857, -11184.583, 12868.502)",
    fill: "#fae8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16204",
    "data-name": "Trazado 16204",
    d: "M0,.684A.665.665,0,0,1,.7,0C2.154.075,3.38.17,4.312.253c2.375.21,1.407.213,4.19.5,1.858.193,2.817.246,3.8.966a4.52,4.52,0,0,1,1.1,1.173,7.094,7.094,0,0,1-2.927,4.7A6.885,6.885,0,0,1,6.013,8.7a6.7,6.7,0,0,1-2.7-1.012C.477,5.819.048,2.236,0,.684",
    transform: "translate(-11182.9 12864.394) rotate(-169)",
    fill: "#f2b05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16205",
    "data-name": "Trazado 16205",
    d: "M0,1.7a6.08,6.08,0,0,0,5.151.382A5.594,5.594,0,0,0,7.6,0a4.438,4.438,0,0,1-2,3.043,4.33,4.33,0,0,1-4.347.028A2.447,2.447,0,0,1,0,1.7",
    transform: "translate(-11183.415 12860.326) rotate(-169)",
    fill: "#c6783a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.fcb91fbefb10080c9aaf5a1774dd8499.svg";
export { ForwardRef as ReactComponent };